import { render, staticRenderFns } from "./Sparkline.vue?vue&type=template&id=54a4efa4&scoped=true"
import script from "./Sparkline.vue?vue&type=script&lang=js"
export * from "./Sparkline.vue?vue&type=script&lang=js"
import style0 from "./Sparkline.vue?vue&type=style&index=0&id=54a4efa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a4efa4",
  null
  
)

export default component.exports